module.exports = __webpack_public_path__ + "7b32da9a5d8153c9a3020bc4e0c61680.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/rising-blue.png
// module id = 604
// module chunks = 0